import queryString, { ParsedQuery } from 'query-string';
import { Purchases } from "../constants/Purchases";

export default class UrlService {

  public static getUrl(): string {
    return window.location.pathname.split(/(sr|en)/gm)[0].slice(0, -1);
  }

  public static getUrlPath(): string {
    return window.location.pathname;
  }

  public static getParamsFromUrlOnLoadPage(): ParsedQuery {
    return queryString.parse(window.location.search); // parsed query string to Json
  }

  public static getUrlParameter(url: string, param: string): string | null {
    const urlObject = new URL(url);
    return urlObject.searchParams.get(param);
  }

  public static isCosmos(): boolean {
    const params = this.getParamsFromUrlOnLoadPage();
    return typeof params !== 'undefined' && Object.keys(params).length > 0 && params.purchase === Purchases.COSMOS;
  }

  public static getPurchase(): string {
    return this.isCosmos() ? Purchases.COSMOS : Purchases.SUBSIDY;
  }

}
